import { MessageModalProps } from "core/utils/modals";
import { InfoCircle } from "react-bootstrap-icons";
import { PrimaryButton } from "../../buttons/buttons";
import Modal from "../modal/modal";

const footer = (close: VoidFunction) => (
	<PrimaryButton onClick={close}>Aceptar</PrimaryButton>
);

const AlertModal = (props: MessageModalProps) => {
	return (
		<Modal parent={props.parent} footer={footer} onClosed={props.onClosed}>
			<div className="text-center">
				<InfoCircle className="modal-icon" /><br />
				<strong>{props.message}</strong>
			</div>
		</Modal>
	);
};

export default AlertModal;